import { styled } from "styled-components";
import { Button, Image, Text } from "@chakra-ui/react";
import { useContext, useEffect, useState } from "react";

import { convertFontSize } from "./Util";
import { ScreenContext } from "./ScreenProvider";
import {ReactComponent as iconLeft} from "../assets/icons/icon-arrow-left.svg";
import {ReactComponent as iconRight} from "../assets/icons/icon-arrow-right.svg";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const SlideSection = styled.div`
  width: 80vw;
  height: 100%;
  overflow-x: hidden;
`;

const SlideWrapper = styled.div<{ $move: number }>`
  display: flex;
  width: 100%;
  height: 100%;

  transform: translateX(-${(props)=>props.$move}px);
  transition: transform 0.5s ease-in-out;
`;

const SlideItem = styled.div`
// 240 * 367 mobile
  min-width: calc(25% - 30px);
  position: relative;
  width: 20%;
  height: 100%;
  margin: 0 15px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  img {
    width: 100%;
    height: fit-content;
    object-fit: contain;
  }

  @media (max-width: 768px) {
    min-width: calc(100% - 30px);
    width: 100%;
  }
`;

const TextBox = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: transparent;
  justify-content: space-evenly;
  align-items: center;
  padding: 5%;
`;

const ArrowLeft = styled(iconLeft)`
  width: 10%;
  stroke: #969696;
  &:hover {
    stroke: #27C4D5;
  }
  @media (max-width: 768px) {
    width: 80%;
  }
`;

const ArrowRight = styled(iconRight)`
  width: 10%;
  stroke: #969696;
  &:hover {
    stroke: #27C4D5;
  }
  @media (max-width: 768px) {
    width: 80%;
  }
`;

const SlideContents = ({
  datas,
}) => {
  const screen = useContext(ScreenContext).style;
  const [isFirst, setIsFirst] = useState<boolean>(true);
  const [dataIndex, setDataIndex] = useState<number>(0);
  const max = document.querySelectorAll('.data').length;
  const [lastNum, setLastNum] = useState<number>(3);
  const [move, setMove] = useState<number>(0);

  const handlePrev = (e) => {
    if(dataIndex === 0) return;
    setDataIndex(prev => prev - 1);
  };  

  const handleNext = (e) => {
    // if(dataIndex === max - 1) return;
    if(dataIndex >= max - 1 - lastNum) return;
    setDataIndex(prev => prev + 1);
  };  

  useEffect(() => {
    if(isFirst) {
      setIsFirst(false);
      return;
    }
    const dataList = document.querySelectorAll('.data');
    const data = dataList[dataIndex];
    const width = data.clientWidth;
    setMove((width + 30) * dataIndex);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataIndex]);

  const [isHover, setIsHover] = useState<boolean[]>([]);

  const onMouseEnter = (index: number) => {
    setIsHover(isHover.map((h, id) => { return id === index; }));
  };

  const onMouseMove = (index: number) => {
    setIsHover(isHover.map((h, id) => { return id === index; }));
  };

  const onMouseLeave = () => {
    setIsHover(isHover.map(() => { return false; }));
  };

  useEffect(() => {
    if(!datas) return;
    const list = [];
    datas.forEach(() => {
      list.push(false);
    });
    setIsHover(list);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [datas]);

  useEffect(() => {
    if(!screen || screen === "") return;
    let last = 0;
    if(screen !== "mobile") {
      last = 3;
    }
    setLastNum(last);
  }, [screen]);

  return (
    <Container>
      <Button 
        w={"10%"}
        onClick={handlePrev} 
        // backgroundImage={arrowLeft} 
        backgroundRepeat={"no-repeat"} 
        backgroundPosition={"center"}
        backgroundColor={"transparent"}
        _hover={{
          // backgroundImage: arrowLeft,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundColor: "transparent",
        }}
      >
        <ArrowLeft />
      </Button>
      <SlideSection>
        <SlideWrapper $move={move}>
          {datas?.map((item, index) => {
            return (
              <SlideItem 
                key={index} 
                className="data"
                onMouseEnter={() => onMouseEnter(index)} 
                onMouseMove={() => onMouseMove(index)} 
                onMouseLeave={onMouseLeave}
              >
                <Image src={item.image} width={"auto"} height={"100%"} alt="" />
                <TextBox>
                  <Text 
                    fontSize={
                      screen === "pc" ? convertFontSize(8, 24) : convertFontSize(18, 24, screen)
                    } 
                    fontWeight={600} 
                    textAlign={"center"} 
                    whiteSpace={"pre-wrap"}
                  >
                    {item.title[screen]}
                  </Text>
                  {isHover[index] && 
                    <Text 
                      fontSize={
                        screen === "pc" ? convertFontSize(8, 20) : convertFontSize(10, 14, screen)
                      } 
                      fontWeight={600} 
                      textAlign={"center"} 
                      whiteSpace={"pre-wrap"}
                    >
                      {item.desc}
                    </Text>
                  }
                </TextBox>
              </SlideItem>
            )
          })}
        </SlideWrapper>  
      </SlideSection>      
      <Button 
        w={"10%"}
        onClick={handleNext}
        // backgroundImage={arrowRight} 
        backgroundRepeat={"no-repeat"} 
        backgroundPosition={"center"}
        backgroundColor={"transparent"}
        _hover={{
          // backgroundImage: arrowRight,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundColor: "transparent",
        }}
      >
        <ArrowRight />
      </Button>
    </Container>
  );
};

export default SlideContents;